import React from 'react';
import ImportModal from '../common/ImportModal';
import { useTranslation } from 'react-i18next';

const ProductImportModal = ({
  isOpen,
  onClose,
  onImport,
  importing = false,
  importError = null,
  importSuccess = false,
}) => {
  const { t } = useTranslation();

  // Per-column guidance for the template's "Instructions" sheet. Keyed by the
  // exact header labels used in the catalogue import template.
  const NOTES = t('importTemplate.notes', { returnObjects: true });
  const TEMPLATE_COLUMN_SPECS = {
    'Product Name': { required: true },
    'Category': { required: true, note: NOTES.matchCategory },
    'Alias Name': { required: false },
    'Product Size': { required: false },
    'Product Weight': { required: false, note: NOTES.weightKg },
    'Standard Length': { required: false, note: NOTES.standardLengthM },
    'Product Thickness': { required: false },
  };

  const importConfig = t('productCatalogue.import.config', { returnObjects: true });

  return (
    <ImportModal
      isOpen={isOpen}
      onClose={onClose}
      onImport={onImport}
      importing={importing}
      importError={importError}
      importSuccess={importSuccess}
      templateHeaders={importConfig.templateHeaders}
      templateColumnSpecs={TEMPLATE_COLUMN_SPECS}
      templateFilename={importConfig.templateFilename}
      inputId={importConfig.inputId}
      skipHeaderValidation={true}
    />
  );
};

export default ProductImportModal;